import {
  ENTREPRISES_SEARCH_REQUEST,
  ENTREPRISES_SEARCH_SUCCESS,
  ENTREPRISES_SEARCH_FAILURE,
  ENTREPRISES_FETCH_DETAIL_REQUEST,
  ENTREPRISES_FETCH_DETAIL_SUCCESS,
  ENTREPRISES_FETCH_DETAIL_FAILURE,
  ENTREPRISES_FETCH_COMPANY_REQUEST,
  ENTREPRISES_FETCH_COMPANY_SUCCESS,
  ENTREPRISES_FETCH_COMPANY_FAILURE,
  ENTREPRISES_FETCH_STATS_REQUEST,
  ENTREPRISES_FETCH_STATS_SUCCESS,
  ENTREPRISES_FETCH_STATS_FAILURE,
  ENTREPRISES_AUTOCOMPLETE_REQUEST,
  ENTREPRISES_AUTOCOMPLETE_SUCCESS,
  ENTREPRISES_AUTOCOMPLETE_FAILURE,
  ENTREPRISES_SET_FILTERS,
  ENTREPRISES_CLEAR_FILTERS,
  ENTREPRISES_SET_QUERY,
  ENTREPRISES_SET_PAGE,
  ENTREPRISES_RESET,
} from "../actions/types"

const initialState = {
  // Search results
  items: [],
  query: '',
  hadResults: false,

  // Current detail views
  annonceDetail: null,
  companyProfile: null,

  // Stats (for landing page)
  stats: null,

  // Autocomplete
  autocompleteResults: [],

  // Facets (from search response)
  facets: {
    type_annonce: [],
    forme_juridique: [],
    ville: [],
    secteur_principal: [],
    statut_societe: [],
    annee_publication: [],
  },

  // Active filters
  filters: {},

  // Pagination
  pagination: {
    page: 1,
    page_size: 20,
    total: 0,
    total_pages: 0,
  },

  // Loading states
  loading: {
    search: false,
    detail: false,
    company: false,
    stats: false,
    autocomplete: false,
  },

  // Error states
  errors: {
    search: null,
    detail: null,
    company: null,
    stats: null,
    autocomplete: null,
  },
}

const entreprisesReducer = (state = initialState, action) => {
  switch (action.type) {
    // ── Search ──
    case ENTREPRISES_SEARCH_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, search: true },
        errors: { ...state.errors, search: null },
      }
    case ENTREPRISES_SEARCH_SUCCESS: {
      const { applied_filters } = action.payload
      // When backend auto-resolved query → filter, merge into active filters & clear query
      const newFilters = applied_filters
        ? { ...state.filters, ...applied_filters }
        : state.filters
      const newQuery = applied_filters ? '' : state.query
      return {
        ...state,
        items: action.payload.items,
        facets: action.payload.facets,
        pagination: action.payload.pagination,
        filters: newFilters,
        query: newQuery,
        hadResults: true,
        loading: { ...state.loading, search: false },
      }
    }
    case ENTREPRISES_SEARCH_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, search: false },
        errors: { ...state.errors, search: action.payload },
      }

    // ── Detail ──
    case ENTREPRISES_FETCH_DETAIL_REQUEST:
      return {
        ...state,
        annonceDetail: null,
        loading: { ...state.loading, detail: true },
        errors: { ...state.errors, detail: null },
      }
    case ENTREPRISES_FETCH_DETAIL_SUCCESS:
      return {
        ...state,
        annonceDetail: action.payload,
        loading: { ...state.loading, detail: false },
      }
    case ENTREPRISES_FETCH_DETAIL_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, detail: false },
        errors: { ...state.errors, detail: action.payload },
      }

    // ── Company Profile ──
    case ENTREPRISES_FETCH_COMPANY_REQUEST:
      return {
        ...state,
        companyProfile: null,
        loading: { ...state.loading, company: true },
        errors: { ...state.errors, company: null },
      }
    case ENTREPRISES_FETCH_COMPANY_SUCCESS:
      return {
        ...state,
        companyProfile: action.payload,
        loading: { ...state.loading, company: false },
      }
    case ENTREPRISES_FETCH_COMPANY_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, company: false },
        errors: { ...state.errors, company: action.payload },
      }

    // ── Stats ──
    case ENTREPRISES_FETCH_STATS_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, stats: true },
        errors: { ...state.errors, stats: null },
      }
    case ENTREPRISES_FETCH_STATS_SUCCESS:
      return {
        ...state,
        stats: action.payload,
        loading: { ...state.loading, stats: false },
      }
    case ENTREPRISES_FETCH_STATS_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, stats: false },
        errors: { ...state.errors, stats: action.payload },
      }

    // ── Autocomplete ──
    case ENTREPRISES_AUTOCOMPLETE_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, autocomplete: true },
      }
    case ENTREPRISES_AUTOCOMPLETE_SUCCESS:
      return {
        ...state,
        autocompleteResults: action.payload,
        loading: { ...state.loading, autocomplete: false },
      }
    case ENTREPRISES_AUTOCOMPLETE_FAILURE:
      return {
        ...state,
        autocompleteResults: [],
        loading: { ...state.loading, autocomplete: false },
      }

    // ── UI State ──
    case ENTREPRISES_SET_FILTERS:
      return { ...state, filters: action.payload }
    case ENTREPRISES_CLEAR_FILTERS:
      return { ...state, filters: {}, pagination: { ...state.pagination, page: 1 } }
    case ENTREPRISES_SET_QUERY:
      return { ...state, query: action.payload }
    case ENTREPRISES_SET_PAGE:
      return { ...state, pagination: { ...state.pagination, page: action.payload } }
    case ENTREPRISES_RESET:
      return { ...initialState, stats: state.stats }

    default:
      return state
  }
}

export default entreprisesReducer
